import Squircle from "@/components/Squircle";

export default function Button({ children }) {
	return (
		<>
			<div className="button-container">
				<span className={`btn`}>{children}</span>
				<Squircle size="button"></Squircle>
			</div>
		</>
	);
}
